export default __webpack_public_path__ + "static/media/North-0-St.28678476.svg";